import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import TabPane from "../../../components/Tab/TabPane";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";

function ServicoTab({ tabAtualHook, valuesHook, checkServicoTab }) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabAtualHook;

  return (
    <TabPane id="servicoTab">
      <div className="row mb-3">
        <div className="col-12">
          <CommonTextArea
            label="Descrição do serviço prestado"
            id="descricaoServicoPrestado"
            value={values.descricaoServicoPrestado}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            rows={5}
            required
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-4">
          <CommonInputValor
            label="Valor total"
            id="valorTotal"
            value={values.valorTotal}
            onChange={(e) => {
              handleChangeNameValue(
                "valorTotal",
                e.target.value,
                values,
                setValues
              );
            }}
            required
          />
        </div>
      </div>
      <div className="row mb-3 mx-0 gap-3 justify-content-between">
        <CommonButton
          onClick={() => {
            TabHelper.trocarTab(tabAtual, setTabAtual, -1);
          }}
          color="primary"
        >
          Anterior
        </CommonButton>
        <CommonButton
          onClick={() => {
            if (checkServicoTab())
              TabHelper.trocarTab(tabAtual, setTabAtual, 1);
          }}
          color="primary"
        >
          Próximo
        </CommonButton>
      </div>
    </TabPane>
  );
}

ServicoTab.propTypes = {
  tabAtualHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  checkServicoTab: PropTypes.func.isRequired,
};

export default ServicoTab;
